export const style = {
  typography: {
    variant: 'h6',
    color: 'text.primary',
    sx: {
      px: 2,
    },
  },
} as const;
